import React, { Component } from "react";
import menuMaster from "../../menu";
import MenuHeading from "../../components/Menu/MenuHeading";
import MenuLink from "../../components/Menu/MenuLink";
import MenuEnd from "../../components/Menu/MenuEnd";
import { Scrollbars } from "react-custom-scrollbars";

class SideMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: []
    };
  }

  componentWillMount() {
    this.setMenu(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.setMenu(nextProps);
  }

  setMenu(props) {
    for (var i = 0; i < menuMaster.length; i++) {
      if (menuMaster[i].section.toUpperCase() === props.section.toUpperCase()) {
        this.setState({ options: menuMaster[i].menu });
      }
    }
  }

  render() {
    var e = this;
    var options = this.state.options.map(function(item, index) {
      return (
        <div key={index}>
          {item.heading === true ? (
            <MenuHeading name={"menuFind_" + item.link} text={item.title} />
          ) : (
            <MenuLink
              name={"menuFind_" + item.link}
              text={item.title}
              to={
                e.props.article === undefined
                  ? e.props.section + "#" + item.link
                  : e.props.section + "/" + item.link
              }
            />
          )}
        </div>
      );
    });

    return (
      <div className="showBig sideMenu" style={{ height: "100%" }}>
        <div id="sideMenu" className="sideMenuInside">
          <Scrollbars style={{ height: "calc(100% - 76px)" }}>
            {options}
          </Scrollbars>
        </div>
      </div>
    );
  }
}

export default SideMenu;



// WEBPACK FOOTER //
// ./src/components/Menu/SideMenu.js